import { Build, h, Host } from "@stencil/core";
const asyncFilter = (array, filterFn) => {
    return new Promise(resolve => {
        const booleanArr = [];
        array.forEach(function (e) {
            booleanArr.push(filterFn(e));
        });
        Promise.all(booleanArr).then((result) => resolve(array.filter((_, i) => result[i])));
    });
};
const elementInViewport = (el) => {
    let top = el.offsetTop;
    let left = el.offsetLeft;
    let width = el.offsetWidth;
    let height = el.offsetHeight;
    let parent = el;
    while (parent.offsetParent) {
        parent = parent.offsetParent;
        top += parent.offsetTop;
        left += parent.offsetLeft;
    }
    return (top < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset);
};
export class Form {
    constructor() {
        this.skipValidation = false;
    }
    componentDidLoad() {
        if (!Build.isBrowser) {
            return;
        }
        this.onSubmitListener = this.onSubmit.bind(this);
        this.form.setAttribute('novalidate', 'novalidate');
        this.form.addEventListener('submit', this.onSubmitListener);
        this.inputs = this.el.querySelectorAll('input,textarea,select,uvex-select');
        this.inputs.forEach((input) => {
            input.addEventListener('blur', () => {
                this.setFieldState(input);
            });
        });
    }
    disconnectedCallback() {
        this.form.removeEventListener('submit', this.onSubmitListener);
    }
    async isSkipped() {
        return this.skipValidation;
    }
    async checkValidity() {
        if (this.skipValidation) {
            return true;
        }
        const invalidInputs = await this.invalidInputs();
        return invalidInputs.length == 0 && this.form.checkValidity();
    }
    async invalidInputs() {
        return await asyncFilter(Array.from(this.inputs), async (el) => !await el.checkValidity());
    }
    setFieldState(input) {
        if (input.checkValidity()) {
            input.parentElement.classList.remove('has-danger');
        }
        else {
            input.parentElement.classList.add('has-danger');
        }
    }
    async onSubmit(event) {
        if (this.skipValidation) {
            this.formSubmit.emit();
            return;
        }
        const isValid = await this.checkValidity();
        if (isValid) {
            this.formSubmit.emit();
        }
        else {
            event.preventDefault();
            event.stopPropagation();
            const invalidInputs = await this.invalidInputs();
            if (invalidInputs.length) {
                this.inputs.forEach((input) => {
                    this.setFieldState(input);
                });
                const invalidInput = invalidInputs[0];
                invalidInput.reportValidity();
                if (!elementInViewport(invalidInput)) {
                    window.requestAnimationFrame(() => invalidInput.scrollIntoView());
                }
            }
        }
    }
    get form() {
        return this.el.querySelector('form');
    }
    render() {
        return (h(Host, { key: '19a7e7466790e715ee47b21fbe6b474d162f09f5' }, h("slot", { key: '74943917d4b92a87e977b9796e83e651bac97e4d' })));
    }
    static get is() { return "uvex-form"; }
    static get originalStyleUrls() {
        return {
            "$": ["./form.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["form.css"]
        };
    }
    static get events() {
        return [{
                "method": "formSubmit",
                "name": "submit",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "void",
                    "resolved": "void",
                    "references": {}
                }
            }];
    }
    static get methods() {
        return {
            "isSkipped": {
                "complexType": {
                    "signature": "() => Promise<boolean>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<boolean>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            },
            "checkValidity": {
                "complexType": {
                    "signature": "() => Promise<boolean>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<boolean>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=form.js.map
